var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.model.viewDirection === 'horizontal')?_c('Horizontal',{attrs:{"model":_vm.model}}):_vm._e(),_vm._v(" "),(_vm.model.viewDirection === 'vertical')?_c('Vertical',{attrs:{"model":_vm.model}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }